export class ResponseMessage {

  ServiceResposeMessage: string;

  ResponseErrorCode: string;

  ResponseMessageType: string;
}
